import { render, staticRenderFns } from "./OriginRecordOp.vue?vue&type=template&id=2f25b130&scoped=true&"
import script from "./OriginRecordOp.vue?vue&type=script&lang=js&"
export * from "./OriginRecordOp.vue?vue&type=script&lang=js&"
import style0 from "./OriginRecordOp.vue?vue&type=style&index=0&id=2f25b130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f25b130",
  null
  
)

export default component.exports